import React, { useEffect, useMemo, useState } from 'react';
import {
  Badge,
  Button,
  Drawer,
  message,
  Modal,
  Popover,
  Divider,
  Tooltip as AntdToolTip,
  Menu,
} from 'antd';
import axios from 'axios';
import Icon, {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  InboxOutlined,
  LinkOutlined,
  MoreOutlined,
  SettingOutlined,
  ShareAltOutlined,
  LogoutOutlined,
  FormOutlined,
  ExclamationCircleFilled,
  PushpinOutlined,
  PushpinFilled,
  ClockCircleOutlined,
  WarningFilled,
} from '@ant-design/icons';

import {
  Edit,
  ExternalLink,
  Share2,
  Inbox,
  MoreVertical,
  Copy,
  Trash2,
  ChevronRight,
  ArrowRight,
  Settings,
} from 'react-feather';

import { useMediaQuery } from 'react-responsive';

import { getFormLimit, hasFeature } from '../../utils/restrictions';
import { showUpselling } from '../../store/actions/paymentActions';

import { useDispatch, useSelector } from 'react-redux';
import { convertGoogleForm, deleteForm, duplicateForm } from '../../store/actions/formActions';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { checkForAdvancedFields } from '../../utils/helpers';
import { pinForm, unpinForm } from '../../store/actions/userActions';
import { Default, deviceWidth, Mobile } from '../../utils/media-query';

const { confirm } = Modal;
const key = 'updatable';

const Tooltip = ({ children, title }) => {
  return (
    /*   <AntdToolTip
      title={title}
      color="#eee"
      overlayStyle={{
        borderRadius: '4px',
      }}
      overlayInnerStyle={{
        fontSize: '12px',
        fontFamily: 'sans-serif',
        color: 'black',
      }}
    >
      {children}
    </AntdToolTip> */
    <div title={title}>{children}</div>
  );
};

const MoreMenu = (item, forms, setVisible, user) => {
  const isStillGoogleForm = item.formId && !item.from;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleDelete = () => {
    setVisible(false);
    confirm({
      title: t('delete.title', { name: item.name }),
      icon: <ExclamationCircleOutlined />,
      content: isStillGoogleForm ? t('delete.content') : '',
      okText: t('delete.ok'),
      cancelText: t('delete.cancel'),
      okType: 'danger',
      okButtonProps: { type: 'primary' },
      onOk() {
        return dispatch(deleteForm(item.id)).catch(() => {});
      },
    });
  };

  const handleCreateDuplicateForm = () => {
    setVisible(false);
    if (forms.length >= getFormLimit(user.plan, user.maxFormCount)) {
      dispatch(showUpselling('formcount', getFormLimit(user.plan, user.maxFormCount)));
    } else {
      message.loading({ content: t('message.createLoading', { name: item.name }), key });
      dispatch(duplicateForm({ templateId: item.id }))
        .then(() => message.success({ content: t('message.createSuccess'), key }))
        .catch(() => message.error({ content: t('message.somethingWrong'), key }));
    }
  };

  const handlePinForm = () => {
    setVisible(false);
    if (item.pinned) {
      dispatch(unpinForm(item.id));
    } else {
      dispatch(pinForm(item.id));
    }
  };
  return (
    <div>
      {/* <div className="sub-menu-item" onClick={handlePinForm}>
        <a key="list-convert">
          <PushpinOutlined /> {item.pinned ? t('unpin') : t('pin')}
        </a>
      </div> */}
      <div className="sub-menu-item" onClick={handleCreateDuplicateForm}>
        <a key="list-convert">
          <CopyOutlined /> {t('duplicate')}
        </a>
      </div>
      <div className="sub-menu-item">
        <Link to={`/forms/${item.id}/settings`} key="list-convert">
          <SettingOutlined /> {t('settings')}
        </Link>
      </div>
      <div className="sub-menu-item" onClick={handleDelete}>
        <a>
          <DeleteOutlined /> {t('delete.text')}
        </a>
      </div>
    </div>
  );
};

const Card = ({ form, forms, analytics, user, setOptionsDrawerVisible }) => {
  const [visible, setVisible] = useState(false);
  const [unreadResponses, setUnreadResponses] = useState(0);
  const [convertLoading, setConvertLoading] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };
  const isStillGoogleForm = form.formId && !form.from;
  const isPinned = form.pinned;

  const { error } = useSelector((state) => state.form);
  const { me } = useSelector((state) => state.auth);
  const isMobile = useMediaQuery({ maxWidth: deviceWidth.mobile });

  const formHasAdvancedFields = checkForAdvancedFields(form.formQuestions);
  const planHasAdvancedFields = hasFeature(me.plan, 'advancedFields');

  const showDisabledFormAlert = formHasAdvancedFields && !planHasAdvancedFields;

  useEffect(() => {
    const item = analytics.find((item) => item.form === form.id);
    if (item && item.unread) setUnreadResponses(item.unread);
  }, [analytics, form]);

  const handlePinForm = () => {
    if (isMobile) {
      return;
    }
    if (form.pinned) {
      dispatch(unpinForm(form.id));
    } else {
      dispatch(pinForm(form.id));
    }
  };

  return (
    <Badge count={isMobile ? unreadResponses : 0} style={{ backgroundColor: '#52c41aee' }}>
      <div
        className={classNames('card', {
          active: visible,
          blocked: form.blocked,
        })}
        {...(isMobile && {
          onClick: () => {
            setOptionsDrawerVisible(form.id);
          },
        })}
      >
        <div>
          <div className="card-header">
            <Default>
              <Link to={`/forms/${form.id}/build`}>
                <h4 className="card-title">
                  <span>{form.name}</span>

                  {showDisabledFormAlert && (
                    <AntdToolTip title={t('builder:advancedFieldsDisabled')} placement="right">
                      <ExclamationCircleFilled style={{ color: 'red' }} />
                    </AntdToolTip>
                  )}
                </h4>
              </Link>
            </Default>
            <Mobile>
              <h4 className="card-title">
                <span>{form.name}</span>

                {showDisabledFormAlert && (
                  <AntdToolTip title={t('builder:advancedFieldsDisabled')} placement="right">
                    <ExclamationCircleFilled style={{ color: 'red' }} />
                  </AntdToolTip>
                )}
              </h4>{' '}
            </Mobile>
            <span className="card-more">
              {isPinned ? (
                <Tooltip placement="bottom" title={t('unpin', 'Unpin')}>
                  <Button
                    type="text"
                    shape="circle"
                    icon={<PushpinFilled />}
                    onClick={handlePinForm}
                  />
                </Tooltip>
              ) : (
                <Tooltip placement="bottom" title={t('pin', 'Pin')}>
                  <Button
                    type="text"
                    shape="circle"
                    icon={<PushpinOutlined />}
                    className="pin-button"
                    onClick={handlePinForm}
                  />
                </Tooltip>
              )}
              <Popover
                className="card-more-popover"
                content={() => MoreMenu(form, forms, setVisible, user)}
                placement="bottomRight"
                visible={visible}
                onVisibleChange={handleVisibleChange}
                trigger="click"
              >
                <Button type="text" shape="circle" icon={<MoreOutlined />} />
                {/* <MoreOutlined /> */}
              </Popover>
            </span>
          </div>
          <p
            className="card-link"
            style={{
              marginTop: isMobile ? '14px' : '0px',
            }}
          >
            <a
              onClick={(e) => e.stopPropagation()}
              href={`https://whatsform.com/${form.link}`}
              target="_blank"
              rel="noreferrer"
            >
              whatsform.com/{form.link}{' '}
              <Icon viewBox="0 0 15 15">
                <ExternalLink size="1rem" />
              </Icon>
            </a>
          </p>
        </div>

        <div className="card-footer">
          <Tooltip title="Build">
            {isStillGoogleForm ? (
              <a
                href={`https://docs.google.com/forms/d/${form.formId}/edit`}
                target="_blank"
                rel="noreferrer"
              >
                <div className="card-phone">
                  <EditOutlined />
                  {t('card.edit')}
                </div>
              </a>
            ) : (
              <Link to={`/forms/${form.id}/build`}>
                <div className="card-phone">
                  <EditOutlined />
                  {t('card.edit')}
                </div>
              </Link>
            )}
          </Tooltip>

          <Tooltip title="Share">
            <Link to={`/forms/${form.id}/share`}>
              <div className="card-phone">
                {' '}
                <ShareAltOutlined /> {t('card.share')}
              </div>
            </Link>
          </Tooltip>

          {/* Responses are only for native type forms */}
          {!isStillGoogleForm && (
            <Tooltip title="Responses">
              <Link to={`/forms/${form.id}/responses`}>
                <div className="card-phone">
                  <InboxOutlined />
                  {t('card.responses')}
                  {/* {true ? (
                  <Tooltip title="Storage limit reached">
                    <Badge count={<ExclamationCircleFilled style={{ color: '#f9ab00' }} />}></Badge>
                  </Tooltip>
                ) : ( */}
                  <Badge style={{ backgroundColor: '#52c41aee' }} count={unreadResponses}></Badge>
                  {/* )} */}
                </div>
              </Link>
            </Tooltip>
          )}
        </div>
      </div>
    </Badge>
  );
};

export const FormOptionsDrawer = ({
  activeForm,
  optionsDrawerVisible,
  setOptionsDrawerVisible,
  analytics,
  forms,
  user,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [unreadResponses, setUnreadResponses] = useState(0);

  const analytic = useMemo(
    () => analytics.find((item) => item.form === activeForm?.id),
    [analytics, activeForm],
  );

  const handleDelete = () => {
    setOptionsDrawerVisible(null);
    confirm({
      title: t('delete.title', { name: activeForm.name }),
      icon: <ExclamationCircleOutlined />,
      content: isStillGoogleForm ? t('delete.content') : '',
      okText: t('delete.ok'),
      cancelText: t('delete.cancel'),
      okType: 'danger',
      okButtonProps: { type: 'primary' },
      onOk() {
        return dispatch(deleteForm(activeForm.id)).catch(() => {});
      },
      centered: true,
    });
  };

  const handleCreateDuplicateForm = () => {
    setOptionsDrawerVisible(null);
    if (forms.length >= getFormLimit(user.plan, user.maxFormCount)) {
      dispatch(showUpselling('formcount', getFormLimit(user.plan, user.maxFormCount)));
    } else {
      message.loading({ content: t('message.createLoading', { name: activeForm.name }), key });
      dispatch(duplicateForm({ templateId: activeForm.id }))
        .then(() => message.success({ content: t('message.createSuccess'), key }))
        .catch(() => message.error({ content: t('message.somethingWrong'), key }));
    }
  };

  const handlePinForm = () => {
    setOptionsDrawerVisible(null);
    if (activeForm.pinned) {
      dispatch(unpinForm(activeForm.id));
    } else {
      dispatch(pinForm(activeForm.id));
    }
  };

  const isStillGoogleForm = activeForm?.formId && !activeForm?.from;

  const isPinned = activeForm?.pinned;

  useEffect(() => {
    if (analytic && analytic.unread) setUnreadResponses(analytic.unread);
  }, [analytic]);

  if (!activeForm) return null;
  return (
    <Drawer
      title={activeForm.name}
      placement="bottom"
      closable={true}
      onClose={() => setOptionsDrawerVisible(null)}
      visible={optionsDrawerVisible}
      getContainer={false}
      height="65%"
      width="100%"
      className="form-options-drawer"
    >
      <Menu>
        <Menu.Item key="edit" icon={<EditOutlined />}>
          {isStillGoogleForm ? (
            <a
              href={`https://docs.google.com/forms/d/${activeForm.formId}/edit`}
              target="_blank"
              rel="noreferrer"
            >
              {t('card.edit')}
            </a>
          ) : (
            <Link to={`/forms/${activeForm.id}/build`}>{t('card.edit')}</Link>
          )}
        </Menu.Item>
        <Menu.Item key="share" icon={<ShareAltOutlined />}>
          <Link to={`/forms/${activeForm.id}/share`}>{t('card.share')}</Link>
        </Menu.Item>
        {!isStillGoogleForm && (
          <Menu.Item key="responses" icon={<InboxOutlined />}>
            <Link to={`/forms/${activeForm.id}/responses`}>
              {t('card.responses')}{' '}
              <Badge style={{ backgroundColor: '#52c41aee' }} count={unreadResponses}></Badge>
            </Link>
          </Menu.Item>
        )}
        <Menu.Item key="settings" icon={<SettingOutlined />}>
          <Link to={`/forms/${activeForm.id}/settings`}>{t('settings')}</Link>
        </Menu.Item>
      </Menu>
      <Divider />
      <Menu>
        <Menu.Item key="pin" icon={<PushpinOutlined />} onClick={handlePinForm}>
          {isPinned ? t('unpin', 'Unpin') : t('pin', 'Pin')}
        </Menu.Item>
        <Menu.Item key="duplicate" icon={<CopyOutlined />} onClick={handleCreateDuplicateForm}>
          {t('duplicate')}
        </Menu.Item>
        <Menu.Item key="delete" danger icon={<DeleteOutlined />} onClick={handleDelete}>
          {t('delete.text')}
        </Menu.Item>
      </Menu>
    </Drawer>
  );
};

export default Card;
